import { FormArray, FormGroup } from "@angular/forms";
import { BmMgmFeeFg, BmMgmFeeGroupForm, BmItemForm } from "../../../pojo/bm-form";
import { BmCalcType } from "../../../pojo/bm-enums";
import { BmCalcHelperService } from "../../general/bm-calc-helper.service";
import { BmDefaultFormCreatorService } from "../../general/bm-default-form-creator.service";
import { BmItem } from "../../../pojo/bm-classes";

export class BmGrandTotalMgmFeeCalcService {

  public static createGrandTotalMgmForm(yearsNumber: number): FormArray<FormGroup<BmItemForm>> {
    const items: BmItem[] = BmDefaultFormCreatorService.createItemsArray(yearsNumber);

    return new FormArray<FormGroup<BmItemForm>>(
      items.map((data) => BmCalcHelperService.createBmItemForm(data))
    );
  }

  /**
   * Calculate grand total values for all groups in Management Fee section.
   *
   * HOW IT WORKS:
   * For each period (QUARTER/YEAR) sum соответсвующее value in each total of the groups.
   * If no groups => set 0 values
   *
   * @param mgmFeeFg formGroup with all mgmFeeSectionData
   */
  public static recalculateGrandTotal(mgmFeeFg: FormGroup<BmMgmFeeFg>): void {
    const groupsFA = mgmFeeFg.controls.groups;
    const grandTotalFA = mgmFeeFg.controls.total;
    const totalRowValue = mgmFeeFg.controls.totalRow;
    // if all groups deleted
    if (!groupsFA.length) {
      for (let i = 0; i < grandTotalFA.length; i++) {
        grandTotalFA.at(i).patchValue({ itemValue: 0, calcType: BmCalcType.CALCULATED }, { emitEvent: false });
      }
      return;
    }

    for (let i = 0; i < grandTotalFA.length; i++) {
      let sum = 0;
      groupsFA.controls.forEach((grp: FormGroup<BmMgmFeeGroupForm>) => {
        const v = grp.controls.total.at(i).getRawValue().itemValue ?? 0;
        sum += v;
      });
      grandTotalFA.at(i).patchValue({ itemValue: sum, calcType: BmCalcType.CALCULATED }, { emitEvent: false });
    }

    totalRowValue.patchValue(BmCalcHelperService.recalculateRowTotal(grandTotalFA), { emitEvent: false });
  }
}
